export const PRODUCT_NAME = 'ATLAS MIOFASCIAL™';
export const PRODUCT_PRICE = 24990;
export const PRODUCT_CURRENCY = 'ARS';
export const CHECKOUT_URL = 'https://atlas-miofascial.impultienda.ar/checkout';
export const OFFER_ANCHOR = '#oferta';
export const META_PIXEL_ID = '3123699361155808';
export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/j5rSbBjJ54CAZnFjJ52HGo/Caja_coleccionable_Atlas_miofascial.png';
export const SUPPORT_EMAIL = 'compradigitalyaa@gmail.com';

// Enlaces editables del footer — reemplazá "#" por las URLs reales de tus páginas legales.
export const FOOTER_LINKS = [
  { label: 'Términos y condiciones', href: '#' },
  { label: 'Política de privacidad', href: '#' },
  { label: 'Contacto', href: `mailto:${SUPPORT_EMAIL}` },
];

export const formatPrice = (value: number) => `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
